import { AnyType } from '@src/models/common';
import { IStackRow } from './models';
import { UnitEvent } from './UnitEvent';

interface IParams {
  isDebugMode: boolean;
  rowToSend: IStackRow;
  statUrl: string;
}

export const send = ({ isDebugMode, rowToSend, statUrl }: IParams): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    if (isDebugMode) {
      console.warn('Send to back', rowToSend);
      resolve(true);
    } else {
      if (typeof window !== 'undefined') {
        const result = navigator.sendBeacon(statUrl, JSON.stringify(rowToSend));
        return result ? resolve(true) : reject(result);
      }
    }
  });
};

/**
 * Накидываем к события клика, событие юнита
 * По идеи нужно обернуть onClick для всех кликабельных элементов
 */
export const onUnitClickCallback = (dataId: string, onClick?: (e: AnyType) => void) => {
  return (e: AnyType) => {
    if (!e.unit) {
      e.unit = new UnitEvent({
        details: {
          dataId,
          kind: 'click',
        },
      });
    }

    onClick?.(e);
  };
};
